module.exports = __webpack_public_path__ + "img/Anhänger_SwPu_15000.c8dd53b0.svg";